/**
 * Whether a display name reads like something a machine made.
 *
 * Accounts created by a payment webhook land with names such as
 * `STRIPE_PRO_dhvfy1l8kqf User`, and that name is the headline of a page fans
 * see. Nothing stops the artist keeping it, so this is a warning and never a
 * validation error.
 *
 * The three signals are deliberately narrow, because a false positive nags an
 * artist about their own name:
 *  - an underscore, which no one types into a stage name;
 *  - a run of six or more capitals, which clears MGMT, ABBA and AC/DC;
 *  - a long token mixing letters and digits, which is what a generated id is.
 */
export function looksLikeSystemName(name: string): boolean {
  if (name.includes('_')) {
    return true;
  }
  if (/[A-Z]{6,}/.test(name)) {
    return true;
  }
  return name.split(/\s+/).some(isGeneratedToken);
}

function isGeneratedToken(token: string): boolean {
  if (token.length < 10) {
    return false;
  }
  return /[a-z]/i.test(token) && /\d/.test(token);
}
